import { Box, Typography } from '@mui/material';
import { Database } from '@nozbe/watermelondb';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { UserModel } from 'shared/types/User';
import { getUserFullName } from 'shared/utils/user';

import { OrganisationMembersAvatarGroup } from '@/components';
import { COLOR } from '@/theme/colors';

type Props = {
    database: Database;
    creatorUser: UserModel | null;
    users: UserModel[];
};

function EntryMembers({ database, creatorUser, users }: Props) {
    const { t } = useTranslation();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
            }}
        >
            {creatorUser && (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <Typography
                        fontSize={13}
                        fontWeight={300}
                        color={COLOR.black60}
                    >
                        {t('ShowEntry:created_by')}
                    </Typography>
                    <Typography
                        fontSize={13}
                        fontWeight={400}
                        color={COLOR.black}
                    >
                        {getUserFullName(creatorUser) || creatorUser.email}
                    </Typography>
                </Box>
            )}
            {!!users.length && (
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <Typography
                        fontSize={13}
                        fontWeight={300}
                        color={COLOR.black60}
                    >
                        {t('ShowEntry:section:team_members')}
                    </Typography>
                    <OrganisationMembersAvatarGroup
                        database={database}
                        users={users}
                        testID="EntryPage-TeamMembers"
                        max={3}
                    />
                </Box>
            )}
        </Box>
    );
}

export default EntryMembers;
